import type { ScaleLinear } from 'd3-scale';
import { useTheme } from '@simplywallst/ui-core';

import { VisxText } from '@/components/VisxText';

interface Props {
  yScale: ScaleLinear<number, number>;
  height: number;
  paddingRight: number;
  maximumFormatted: string;
  minimumFormatted: string;
  zeroFormatted: string;
}

const YAxis = ({
  yScale,
  height,
  minimumFormatted,
  maximumFormatted,
  zeroFormatted,
  paddingRight,
}: Props) => {
  const ticks = yScale.ticks(3);
  const zero = yScale(0) as number;
  const theme = useTheme();
  return (
    <>
      <VisxText
        x={paddingRight}
        y={16}
        textAnchor="start"
        fill={theme.color.white}
        typography="tiny"
      >
        {maximumFormatted}
      </VisxText>
      {ticks.map((n) => {
        const y = yScale(n);
        if (y === 24) return null;
        if (y === zero && yScale.domain()[0] === 0) return null;
        return (
          <rect
            key={`grid-row-${n}`}
            y={y}
            height="1"
            width="100%"
            fill={theme.color.white}
            fillOpacity={y === zero ? 1 : 0.1}
          />
        );
      })}
      {!isNaN(zero) && zeroFormatted !== minimumFormatted && zero < height && (
        <VisxText
          x={paddingRight}
          y={zero - 8}
          textAnchor="start"
          fill={theme.color.white}
          typography="tiny"
        >
          {zeroFormatted}
        </VisxText>
      )}
      <VisxText
        x={paddingRight}
        y={height - 8}
        textAnchor="start"
        fill={theme.color.white}
        typography="tiny"
      >
        {minimumFormatted}
      </VisxText>
    </>
  );
};

export default YAxis;
